import debounce from 'lodash.debounce';

/**
 * @description Обработчик изменений в сохраненных данных.
 * @param {StorageChangeNotifier} notifier Уведомитель.
 * @constructor
 */
export function StorageChange(notifier) {
  /**
   * @description Обработчики по их номерам.
   */
  const listeners = new Map();

  /**
   * @description Номер последнего добавленного обработчика.
   * @type {number}
   */
  let lastNumber = 0;

  /**
   * @description Исключить обработчик изменений.
   * @param {string} number Номер обработчика.
   * @returns {boolean}
   */
  this.off = (number) => listeners.delete(number);

  /**
   * @description Добавить обработчик на изменение и получить его номер.
   * @param {string}   id      Идентификатор данных.
   * @param {function} handler Обработчик.
   * @returns {number}
   */
  this.on = (id, handler) => {
    lastNumber += 1;
    listeners.set(lastNumber, { id, handler: debounce(handler, 100) });
    return lastNumber;
  };

  notifier.connect((changedFor) => {
    changedFor.forEach(({ id }) => {
      listeners.forEach(({ id: dataId, handler }) => {
        if (id === dataId) {
          handler();
        }
      });
    });
  });
}

/**
 * @description Уведомитель об изменениях в сохраненных данных.
 * @constructor
 */
export function StorageChangeNotifier() {
  /**
   * @description Обработчик сообщений.
   */
  let handler = null;

  /**
   * @description Подключить обработчик.
   * @param {function} item Обработчик.
   * @returns {void}
   */
  this.connect = (item) => {
    handler = item;
  };

  /**
   * @description Отправить изменения.
   * @param {({id:string}[])} changedFor Изменено для.
   * @returns {void}
   */
  this.push = (changedFor) => {
    if (handler !== null) {
      handler(changedFor);
    }
  };
}
